import { createActionTypes } from 'utils/action/actionTypes';

export const FETCH_DEALER_ENTITLEMENTS = createActionTypes('FETCH_DEALER_ENTITLEMENTS');
export const GET_DEALER_ENTITLEMENT = createActionTypes('GET_DEALER_ENTITLEMENT');
export const FETCH_DEALER_CREDIT_TRANSACTIONS = createActionTypes('FETCH_DEALER_CREDIT_TRANSACTIONS');
export const FETCH_DEALERS = createActionTypes('FETCH_DEALERS');
export const GET_DEALER = createActionTypes('GET_DEALER');
export const UPDATE_DEALER = createActionTypes('UPDATE_DEALER');
export const FETCH_DEALER_BRANCHES = createActionTypes('FETCH_DEALER_BRANCHES');
